/**
 * @public
 */
export function isRoot(options) {
    return (node) => node.parent(options).isNone();
}
//# sourceMappingURL=is-root.js.map